import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";
import env from "./env";

export default class TrackingService {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout, $analytics) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$env = EnvService;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.PubNub = null;
    this.unsortedChannelList = [];
    this.nestedChannelList = [];
    this.arrayOfImageUrlsForGallery = [];
    this.controlChannelVal = null;
    this.$analytics = $analytics;
    this.gaKey = this.$auth.$env.EnvironmentConfig.gaKey;

    //console.log("GA KEY:", this.gaKey);
    window.ga("create", this.gaKey, "auto");
  }

  reportUserLogin(user) {
    this.reportGlobalSubmit("Localytics Logged In", {
      email: user.email,
    });
  }

  reportUserRegistration(user) {
    this.reportGlobalSubmit("Localytics Registered", {
      firstName: user.firstName,
      lastName: user.lastName,
      fullName: user.firstName + " " + user.lastName,
      emailAddress: user.email,
    });
  }

  reportUserLogout() {
    this.reportGlobalSubmit("Localytics Logged Out", {});
  }

  reportJobCancellation(job, user) {
    this.reportGlobalSubmit("Cancel Job", {
      "Business ID": user.company.id,
      "Business Name": user.company.name,
      "Number Of Accepted Applicants": job.numberOfApprovedApplications,
      "Number Of Pending Applicants": job.numberOfPendingApplications,
    });
  }

  reportApplicationAcceptance(job, user, acceptedApplcations) {
    this.reportGlobalSubmit("Hire Jobbler", {
      Email: user.email,
      "Business ID": user.company.id,
      "Business Name": user.company.name,
      "Jobble ID": job.subEvents[0].deduppedJobbles[0].id,
      "Jobble Name": job.name,
      "Number Of Applications Accepted": acceptedApplcations.length,
    });
  }

  reportJobPost(job, jobbleTypes, user) {
    var _this = this;

    var jobbleTypeName = _this.getJobbleTypeName(job.jobble_type, jobbleTypes);
    var rateBucket = _this.getRateRange(job.hourly_rate);
    var rateInCents = job.hourly_rate * 100;
    var jobPostType = _this.getPostingType(job);
    var daysUntil = _this.getDaysTil(job);
    var hoursTil = _this.getHoursTil(job);
    var visibilityType = _this.getVisibilityType(job);
    var isVerifiedUser = _this.getVerifiedUser(user);

    _this.$timeout(() => {
      this.reportGlobalSubmit("Post Job", {
        "Jobble Type": jobbleTypeName,
        "Posting Type": jobPostType,
        "Rate Bucket": rateBucket,
        "Rate in Cents": rateInCents,
        "Number Of Openings": job.openings,
        "Number Of Questions": job.questions.length,
        "Visibility Type": visibilityType,
        "Number Of Shifts": job.timeIntervalsArray.length,
        "Business ID": user.company.id,
        "Business Name": user.company.name,
        "Job Name": job.name,
        "Days Until": daysUntil,
        "Hours Until": hoursTil,
        City: job.timeIntervalsArray[0].contactInfo.city,
        State: job.timeIntervalsArray[0].contactInfo.state,
        Zipcode: job.timeIntervalsArray[0].contactInfo.zipCode,
        "Verification Reminder Display": isVerifiedUser,
      });
    }, 2000);
  }

  getVerifiedUser(user) {
    var isVerified = null;

    if (user.isVerified) {
      isVerified = "TRUE";
    } else {
      isVerified = "FALSE";
    }

    return isVerified;
  }

  getVisibilityType(job) {
    var visibility = null;

    if (job.cloudsForJobblePost.length > 0 && job.postIsPrivate) {
      visibility = "Exclusive";
    }

    if (job.cloudsForJobblePost.length > 0 && !job.postIsPrivate) {
      visibility = "Preferred";
    }

    if (job.cloudsForJobblePost.length === 0) {
      visibility = "Public";
    }

    return visibility;
  }

  getDaysTil(job) {
    return moment(job.timeIntervalsArray[0].startDateAndTimeForDB).diff(moment(), "days");
  }

  getHoursTil(job) {
    return moment(job.timeIntervalsArray[0].startDateAndTimeForDB).diff(moment(), "hours");
  }

  getPostingType(job) {
    var type = null;

    if (job.typeOfJobPosting === "source") {
      type = "Connect";
    } else {
      type = "On-Demand";
    }

    return type;
  }

  getJobbleTypeName(id, jobbleTypes) {
    for (var i = 0; i < jobbleTypes.length; i++) {
      if (jobbleTypes[i].id === id) {
        return jobbleTypes[i].name;
      }
    }
  }

  getRateRange(rate) {
    switch (Math.floor(rate)) {
      case 0:
      case 1:
      case 2:
        return "$0-$2";
      case 3:
      case 4:
      case 5:
        return "$3-$5";
      case 6:
      case 7:
      case 8:
        return "$6-$8";
      case 9:
      case 10:
      case 11:
        return "$9-$11";
      case 12:
      case 13:
      case 14:
        return "$12-$14";
      case 15:
      case 16:
      case 17:
        return "$15-$17";
      case 18:
      case 19:
      case 20:
        return "$18-$20";
      case 21:
      case 22:
      case 23:
        return "$21-$23";
      case 24:
      case 25:
      case 26:
        return "$24-$26";
      case 27:
      case 28:
      case 29:
        return "$27-$29";
      case 30:
      case 31:
      case 32:
        return "$30-$32";
      case 33:
      case 34:
      case 35:
        return "$33-$35";
      case 36:
      case 37:
      case 38:
        return "$36-$38";
      case 39:
      case 40:
      case 41:
        return "$39-$41";

      default:
        return "Over $41";
    }
  }

  reportPostJobClick() {
    this.reportGlobalClick("Post Job Button From Sign In", {});
  }

  reportMarketingRegistration(user) {
    this.reportGlobalSubmit("Marketing Registration", {
      Email: user.email,
    });
  }

  reportMarketingSignIn(user) {
    this.reportGlobalSubmit("Marketing Logged In", {
      Email: user.email,
    });
  }

  reportLazyRegDuringPost(user) {
    this.reportGlobalSubmit("Lazy Registration", {
      Email: user.email,
    });
  }

  reportLazySignInDuringPost(user) {
    this.reportGlobalSubmit("Lazy Logged In", {
      Email: user.email,
    });
  }

  reportOboardingScreenOne(step) {
    if (step === 1) {
      this.reportGlobalClick("Onboarding 1 Skip", {});
    } else {
      this.reportGlobalClick("Onboarding 1 Next Button", {});
    }
  }

  reportOboardingScreenTwo(step) {
    if (step === 1) {
      this.reportGlobalClick("Onboarding 2 Skip", {});
    } else {
      this.reportGlobalClick("Onboarding 2 Next Button", {});
    }
  }

  reportJobTypeSelectionOnDemand() {
    this.reportGlobalClick("On Demand Job Selection", {});
  }

  reportJobTypeSelectionSourcing() {
    this.reportGlobalClick("Connect Job Selection", {});
  }

  reportJobBoardLoad(data) {
    this.reportGlobalSubmit("Jobbler Web Board", {
      Username: data.username,
      Zipcode: data.zipcode,
      "Place ID": data.placeRef,
    });
  }

  reportViewJobFromJobBoard(data) {
    this.reportGlobalView("View Job From Web Board", {
      Username: data.username,
    });
  }

  reportApplyToJobFromBoard(data) {
    this.reportGlobalSubmit("Apply From Web Board", {
      Username: data.username,
    });
  }

  reportHeaderClicks(data) {
    this.reportGlobalClick("Job Web Board Header Clicks", {
      Username: data.username,
      Button: data.button,
    });
  }

  reportNoShows(applications, event) {
    var _this = this;
    let company_name = event.company.name;
    let company_id = event.company.id;
    let event_id = event.id;
    let jobble_type = event.subEvents[0].deduppedJobbles[0].jobbleType.name;
    let state = event.contactInfo.state;
    let city = event.contactInfo.city;
    let zip_code = event.contactInfo.zipCode;
    let pay_per_hour = applications[0].jobble.payPerHour;
    let no_show_count = 0;
    let no_show_count_male = 0;
    let no_show_count_female = 0;
    let no_show_count_other = 0;
    let no_show_no_pay_info = 0;
    let left_note_count = 0;
    let total_hires_count = applications.length;
    try {
      applications.forEach(function (application) {
        if (application.jobble.noShow === true) {
          no_show_count = no_show_count + 1;
          if (application.applicant.gender === "Male") {
            no_show_count_male = no_show_count_male + 1;
          } else if (application.applicant.gender === "Female") {
            no_show_count_female = no_show_count_female + 1;
          } else {
            no_show_count_other = no_show_count_other + 1;
          }
          if (application.noteCount > 0) {
            left_note_count = left_note_count + 1;
          }
          if (application.applicant.undeletedPaymentInfos.length === 0) {
            no_show_no_pay_info = no_show_no_pay_info + 1;
          }
        }
      });
    } finally {
      this.reportGlobalSubmit("No Shows On Job Closure", {
        "Business Name": company_name,
        "Business ID": company_id,
        "Event ID": event_id,
        City: city,
        State: state,
        Zipcode: zip_code,
        "Job Type": jobble_type,
        "Pay Per Hour": pay_per_hour,
        "Total Hires": total_hires_count,
        "No Shows": no_show_count,
        "No Shows Male": no_show_count_male,
        "No Shows Female": no_show_count_female,
        "No Shows Other": no_show_count_other,
        "No Show Left Note": left_note_count,
        "No Show No Pay Info": no_show_no_pay_info,
      });
    }
  }

  reportJobbleBoardFailedJson(data) {
    this.reportGlobalSubmit("Jobble Boad Failure", {
      Zipcode: data.zipcode,
      Radius: data.geoFenceRadius,
      Offset: data.offset,
    });
  }

  handleShiftData(application, shift) {
    var _this = this;
    var data = {};
    data.jobbleId = application.jobble.id;
    data.username = application.applicant.username;
    data.shiftId = shift.id;
    data.street = shift.contactInfo.streetLine1;
    data.city = shift.contactInfo.city;
    data.state = shift.contactInfo.state;
    data.zipCode = shift.contactInfo.zipCode;
    data.shiftStartTime = moment(shift.timeInterval.startTime).format("ddd MMM DD YYYY hh:mm:ss A");
    data.autoCheckinCoords = shift.autoCheckInCoord.lat ? "lat: " + shift.autoCheckInCoord.lat + ", lng: " + shift.autoCheckInCoord.lng : null;
    data.autoCheckinTimestamp = shift.autoCheckOutCoord.dateCreated
      ? moment(shift.autoCheckOutCoord.dateCreated).format("ddd MMM DD YYYY hh:mm:ss A")
      : null;
    data.autoCheckoutCoords = shift.autoCheckOutCoord.lat ? "lat: " + shift.autoCheckOutCoord.lat + ", lng: " + shift.autoCheckOutCoord.lng : null;
    data.autoCheckoutTimestamp = shift.autoCheckOutCoord.dateCreated
      ? moment(shift.autoCheckOutCoord.dateCreated).format("ddd MMM DD YYYY hh:mm:ss A")
      : null;
    data.manualCheckinCoords = shift.checkInCoord.lat ? "lat: " + shift.checkInCoord.lat + ", lng: " + shift.checkInCoord.lng : null;
    data.manualCheckinTimestamp = shift.checkInTime ? moment(shift.checkInTime).format("ddd MMM DD YYYY hh:mm:ss A") : null;
    data.manualCheckoutCoords = shift.checkOutCoord.lat ? "lat: " + shift.checkOutCoord.lat + ", lng: " + shift.checkOutCoord.lng : null;
    data.manualCheckoutTimestamp = shift.checkOutTime ? moment(shift.checkOutTime).format("ddd MMM DD YYYY hh:mm:ss A") : null;
    if (shift.checkInTime) {
      data.checkinDelta = _this.diffTimes(shift.timeInterval.startTime, shift.checkInTime);
    } else {
      data.checkinDelta = null;
    }
    if (shift.checkOutTime) {
      data.checkoutDelta = _this.diffTimes(shift.timeInterval.startTime, shift.checkOutTime);
    } else {
      data.checkoutDelta = null;
    }
    _this.reportShiftData(data);
  }

  reportShiftData(data) {
    this.reportGlobalSubmit("Shift Information", {
      "Jobble Id": data.jobbleId,
      Username: data.username,
      "Shift Id": data.shiftId,
      Street: data.street,
      City: data.city,
      State: data.state,
      "Zip Code": data.zipCode,
      "Shift Start Time": data.shiftStartTime,
      "Checkin Delta": data.checkinDelta,
      "Checkout Delta": data.checkoutDelta,
      "Auto Checkin Coords": data.autoCheckinCoords,
      "Auto Checkout Coords": data.autoCheckoutCoords,
      "Manual Checkin Coords": data.manualCheckinCoords,
      "Manual Checkout Coords": data.manualCheckoutCoords,
      "Auto Checkin Timestamp": data.autoCheckinTimestamp,
      "Auto Checkout Timestamp": data.autoCheckoutTimestamp,
      "Manual Checkin Timestamp": data.manualCheckinTimestamp,
      "Manual Checkout Timestamp": data.manualCheckoutTimestamp,
    });
  }

  diffTimes(time1, time2) {
    var timeDiff = null;
    var diffText = "";
    timeDiff = moment(time1).diff(moment(time2), "minutes");
    if (moment(time2).isAfter(moment(time1))) {
      diffText = timeDiff + " minutes late ";
    } else {
      diffText = timeDiff + " minutes early ";
    }
    return diffText;
  }

  reportJobblerSignUp(data) {
    this.reportGlobalSubmit("sign up - submit - new jobbler sign up", {
      Username: data.username,
      Email: data.email,
    });
  }

  reportJobblerSignUpModal(data) {
    this.reportGlobalSubmit("Jobbler Sign Up Modal", {
      Username: data.username,
      Email: data.email,
    });
  }

  reportJobblerSignUpThirdParty(data) {
    this.reportGlobalSubmit("Jobbler Sign Up Third Party Standard", {
      Username: data.username,
      Email: data.email,
      Type: data.type,
    });
  }

  reportJobblerSignUpThirdPartyOnboarding(data) {
    this.reportGlobalSubmit("Jobbler Sign Up Third Party Onboarding", {
      Username: data.username,
      Email: data.email,
      Type: data.type,
    });
  }

  reportJobsBoardNavBarFilterClick(data) {
    this.reportGlobalClick("Job Board Nav Filter", {
      JobbleType: data.secondary_name,
    });
  }

  reportJobPayOut(data) {
    this.reportGlobalSubmit("Job Pay Outs", {
      Email: data.user,
      "Business ID": data.companyId,
      "Business Name": data.companyName,
      "Jobble Inc User": data.isJobbleAdmin,
      "Fill Rate Percentage After No Shows": data.fillRatePercentageAfterNoShows,
      "Fill Rate Percentage Before No Shows": data.fillRatePercentageBeforeNoShows,
      "Hired Jobblers": data.hiredJobblersCount,
      "Jobble Type": data.jobbleTypeName,
      "Number Of No Shows": data.noShowCount,
      "Remaining Openings": data.openingsLeft,
      "Rate In Cents": data.payPerHourInCents,
      "Potential GMV": data.potentialGMV,
      "Actual GMV": data.totalMoney,
      "Number Of Jobblers Removed From Payment": data.removedFromPaymentCount,
      "Lost GMV": data.revenueLostRounded,
      "Total Number Of Openings": data.totalNumberOfOpenings,
    });
  }

  reportMobileApplication(data) {
    this.reportGlobalSubmit("Device Info on Apply", {
      Email: data.email,
      Device: data.mobile_device_type,
      "User Agent": data.user_agent,
    });
  }

  reportMobileRegisterFromModal(data) {
    this.reportGlobalSubmit("Device Info on Register Modal", {
      Email: data.email,
      Device: data.mobile_device_type,
      "User Agent": data.user_agent,
    });
  }

  reportMobileSigninFromModal(data) {
    this.reportGlobalSubmit("Device Info on Signin Modal", {
      Email: data.email,
      Device: data.mobile_device_type,
      "User Agent": data.user_agent,
    });
  }

  reportHeaderMenuInteraction(data) {
    this.reportGlobalClick("Drop Down Menu Interaction", {
      Email: data.user,
      Button: data.button,
    });
  }

  reportJobSearch(data) {
    this.reportGlobalSubmit("Job Search", {
      Email: data.user,
      "Search Type": data.type,
      "Page Searched From": data.page,
    });
  }

  reportQuickRegister(data) {
    this.reportGlobalSubmit("Quick Register", {
      Email: data.email,
      Phone: data.phone,
      Name: data.first_name + " " + data.last_name,
      Origin: data.ad_origin,
    });
  }

  reportGlobalView(eventName, data) {
    eventName = "web app - " + eventName;

    data = data || {};

    this.currentUser = this.$auth.getUserData();

    if (this.currentUser) {
      data["Email"] = this.currentUser.username;
    }

    console.log("track:", eventName);

    try {
      this.$analytics.eventTrack(eventName, {action: "view"});
    } catch (e) {
      console.error("Error tracking:", e);
    }
  }

  reportGlobalSubmit(eventName, data) {
    eventName = "web app - " + eventName;

    data = data || {};

    this.currentUser = this.$auth.getUserData();

    if (this.currentUser) {
      data["Email"] = this.currentUser.username;
    }

    console.log("track:", eventName);

    try {
      this.$analytics.eventTrack(eventName, {action: "submit"});
    } catch (e) {
      console.error("Error tracking:", e);
    }
  }

  reportGlobalClick(eventName, data) {
    eventName = "web app - " + eventName;

    data = data || {};

    this.currentUser = this.$auth.getUserData();

    if (this.currentUser) {
      data["Email"] = this.currentUser.username;
    }

    console.log("track:", eventName);

    try {
      this.$analytics.eventTrack(eventName, {action: "click"});
    } catch (e) {
      console.error("Error tracking:", e);
    }
  }

  reportClickCategoryFilter(page, filter) {
    const eventName = `${page} - click - category filter`;
    this.reportGlobalClick(eventName, {
      Filter: filter,
    });
  }

  reportClickCompanyFilter(page, filter) {
    const eventName = `${page} - click - company filter`;
    this.reportGlobalClick(eventName, {
      Filter: filter,
    });
  }

  reportClickLocationFilter(page, filter) {
    const eventName = `${page} - click - location filter`;
    this.reportGlobalClick(eventName, {
      Filter: filter,
    });
  }

  reportClickCovidBanner(page) {
    const eventName = `${page} - click - covid banner`;
    this.reportGlobalClick(eventName, {});
  }

  reportClickJobSort(page, sort) {
    const eventName = `${page} - click - sort`;

    if (sort === "payPerHour") {
      sort = "Pay (high to low)";
    } else if (sort === "startTime") {
      sort = "Job Date";
    } else if (sort === "dateCreated") {
      sort = "Date Posted";
    } else {
      sort = "Relevance";
    }

    this.reportGlobalClick(eventName, {
      Sort: sort ? sort.toLowerCase() : sort,
    });
  }

  reportSubmitSearch(page, query, zipcode) {
    const eventName = `${page} - submit - search query`;
    this.reportGlobalSubmit(eventName, {
      Query: query,
      "Zip Code": zipcode,
    });
  }

  reportViewJob(page, job) {
    if (!job) return;

    let zipCode = null;

    if (job.isPartnerPost === true) {
      zipCode = job.partnerPostContent.zip;
    } else {
      if (job.contactInfo) {
        zipCode = job.contactInfo.zipCode;
      } else {
        zipCode = job.subEvent.contactInfo.zipCode;
      }
    }

    const eventName = `${page} - view - job`;
    this.reportGlobalView(eventName, {
      "Jobble Id": job.id,
      "Zip Code": zipCode,
      "Job Category": job.jobbleType.name,
      "Job Title": job.eventName ? job.eventName : job.name ? job.name : "N/A",
      "Job Type": job.is_partner_post ? "Partner Job" : "Platform Job",
    });
  }

  reportSubmitEmailAlert(page, email, job) {
    if (!job) return;

    const eventName = `${page} - submit - job alert sign up`;
    this.reportGlobalSubmit(eventName, {
      Email: email,
      "Jobble Id": job.id,
      "Job Category": job.jobbleType.name,
      "Zip Code": job.subEvent.contactInfo.zipCode,
      "Job Title": job.eventName ? job.eventName : job.subEvent.event.name ? job.subEvent.event.name : "N/A",
      "Job Type": job.is_partner_post ? "Partner Job" : "Platform Job",
    });
  }

  reportSubmitRegistration(page, email) {
    if (!email) return;

    const eventName = `${page} - submit - sign up`;
    this.reportGlobalSubmit(eventName, {
      Email: email,
    });
  }

  reportMobileLinkSent(page, email) {
    if (!email) return;

    const eventName = `${page} - submit - mobile link sent`;
    this.reportGlobalSubmit(eventName, {
      Email: email,
    });
  }

  reportMobileDownload(page, email, type) {
    if (!email) return;

    const eventName = `${page} - submit - mobile download - ${type}`;
    this.reportGlobalSubmit(eventName, {
      Email: email,
    });
  }

  reportSMSVerified(page, email) {
    if (!email) return;

    const eventName = `${page} - submit - sms verified`;
    this.reportGlobalSubmit(eventName, {
      Email: email,
    });
  }

  reportSubmitApplication(page, job) {
    if (!job) return;

    console.log("reportSubmitApplication");
    console.dir(job);
    console.dir(page);
    let zipCode = null;
    let jobName = null;

    if (job.title) {
      jobName = job.title;
    } else if (job.eventName) {
      jobName = job.eventName;
    } else {
      jobName = job.subEvent.event.name;
    }

    if (job.contactInfo) {
      zipCode = job.contactInfo.zipCode;
    } else {
      zipCode = job.subEvent.contactInfo.zipCode;
    }

    const eventName = `${page} - submit - job application`;
    this.reportGlobalSubmit(eventName, {
      "Jobble Id": job.id,
      "Job Category": job.jobbleType.name,
      "Zip Code": zipCode,
      "Job Title": jobName,
      "Job Type": job.is_partner_post ? "Partner Job" : "Platform Job",
    });
  }

  reportSubmitProfileStep(page, step) {
    if (!step) return;

    const eventName = `${page} - submit - profile step - ${step}`;
    this.reportGlobalSubmit(eventName, {});
  }

  reportPostAJobSubmitStep(step) {
    if (!step) return;

    const eventName = `post a job - submit - ${step}`;
    this.reportGlobalSubmit(eventName, {});
  }

  reportPostAJobClick(name) {
    if (!name) return;

    const eventName = `post a job - click - ${name}`;
    this.reportGlobalClick(eventName, {});
  }

  reportRosterPageClick(name) {
    if (!name) return;

    const eventName = `roster page - click - ${name}`;
    this.reportGlobalClick(eventName, {});
  }

  reportRosterPageSubmit(name) {
    if (!name) return;

    const eventName = `roster page - submit - ${name}`;
    this.reportGlobalSubmit(eventName, {});
  }

  reportRosterPageView(name) {
    if (!name) return;

    const eventName = `roster page - view - ${name}`;
    this.reportGlobalView(eventName, {});
  }
}

TrackingService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout", "$analytics"];



// WEBPACK FOOTER //
// ./client/app/services/tracking.js